<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="itemData === null">Create Item</span>
      <span v-else>Update Item</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Membership Program" required>
              <a-select
                v-model="formData.membership_program_id"
                @change="onChangeMembershipProgram"
                :disabled="viewMode || itemData != null"
              >
                <a-select-option
                  v-for="membership_program in options.membershipPrograms"
                  v-bind:value="membership_program.id"
                  v-bind:key="membership_program.id"
                >
                  {{ membership_program.name }}
                </a-select-option>
              </a-select>
              <div
                v-if="$v.formData.membership_program_id.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.membership_program_id.required"
                >
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Membership Levels">
              <a-select
                v-model="formData.membership_levels"
                mode="multiple"
                style="width: 100%"
                :disabled="viewMode"
              >
                <a-select-option
                  v-for="membershipLevel in options.membershipLevels"
                  :key="membershipLevel.id"
                  :value="membershipLevel.id"
                >
                  {{ membershipLevel.name }}
                </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Description" required>
              <a-input
                v-model.trim="$v.formData.description.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.description.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.description.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Code" required>
              <a-input
                v-model.trim="$v.formData.code.$model"
                :disabled="viewMode || itemData != null"
              />
              <div v-if="$v.formData.code.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.code.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Barcode" required>
              <a-input
                v-model.trim="formData.barcode"
                :disabled="viewMode || itemData != null"
              />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Points to redeem" required>
              <a-input
                v-model.trim="$v.formData.points_to_redeem.$model"
                :disabled="viewMode"
              />
              <div
                v-if="$v.formData.points_to_redeem.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.points_to_redeem.required"
                >
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Item Validity" required
              ><br />
              <a-range-picker
                :value="dateRange"
                :format="dateFormat"
                @change="dateRangeOnChange"
                style="width: 100%"
                :disabled="viewMode"
              />
            </base-input>
          </div>
        </div>

        <div class="row d-none">
          <div class="col">
            <base-input label="Item Status" required>
              <a-select v-model="formData.status" :disabled="viewMode">
                <a-select-option
                  v-for="itemStatus in options.itemStatuses"
                  v-bind:value="itemStatus.key"
                  v-bind:key="itemStatus.key"
                >
                  {{ itemStatus.name }}
                </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="itemData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createItem"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="updateItem"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';
import moment from 'moment';

export default {
  name: 'ItemForm',
  props: {
    itemData: Object,
    viewMode: Boolean
  },

  data() {
    return {
      dateFormat: 'YYYY-MM-DD',
      dateRange: [],
      formSubmitting: false,
      statusLabel: 'Active',
      formData: {
        membership_program_id: null,
        membership_levels: null,
        description: null,
        code: null,
        barcode: null,
        points_to_redeem: null,
        valid_from: null,
        valid_to: null,
        status: 'A'
      },
      options: {
        membershipPrograms: [],
        membershipLevels: [],
        itemStatuses: [
          { key: 'A', name: 'Active' },
          { key: 'I', name: 'Inactive' }
        ]
      }
    };
  },

  validations: {
    formData: {
      membership_program_id: {
        required
      },
      description: { required },
      code: { required },
      points_to_redeem: { required },
      valid_from: { required },
      valid_to: { required },
      barcode: { required }
    }
  },

  methods: {
    itemStatusChange(data) {
      this.statusLabel = data ? 'Active' : 'Inactive';
    },
    moment,
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      if (!this.itemData) {
        this.formData.membership_program_id =
          this.options.membershipPrograms[0].id;
        await this.getMembershipLevels(this.options.membershipPrograms[0].id);
      }
    },
    isCurrentDateWithinRange(startDate, endDate) {
      const currentDate = moment();

      const parsedStartDate = moment(startDate).startOf('day');
      const parsedEndDate = moment(endDate).endOf('day');
      return currentDate.isBetween(parsedStartDate, parsedEndDate, null, '[]');
    },
    async getMembershipLevels(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/membership_levels`
      );
      this.options.membershipLevels = data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async createItem() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const isBetween = this.isCurrentDateWithinRange(
          this.formData.valid_from,
          this.formData.valid_to
        );
        if (isBetween) {
          this.formData.status = 'A';
        } else {
          this.formData.status = 'I';
        }
        const response = await HTTPRequest.postRequest('/api/v1/clp_items', {
          item: this.formData
        });

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    async updateItem() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const isBetween = this.isCurrentDateWithinRange(
          this.formData.valid_from,
          this.formData.valid_to
        );
        if (isBetween) {
          this.formData.status = 'A';
        } else {
          this.formData.status = 'I';
        }
        const response = await HTTPRequest.putRequest(
          '/api/v1/clp_items/' + this.itemData.id,
          {
            item: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    dateRangeOnChange(dateObj, dateString) {
      this.formData.valid_from = dateString[0];
      this.formData.valid_to = dateString[1];
      this.dateRange = [dateString[0], dateString[1]];
    },

    filterOption(inputValue, option) {
      let str = option?.componentOptions?.propsData?.label ?? '';
      return str.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1;
    },

    onChangeMembershipProgram() {
      this.formData.membership_levels = null;
      this.getMembershipLevels(this.formData.membership_program_id);
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },

    clearForm() {
      this.dateRange = [];
      this.formData = {
        membership_program_id: null,
        membership_levels: null,
        description: null,
        code: null,
        barcode: null,
        points_to_redeem: null,
        valid_from: null,
        valid_to: null,
        status: 'A'
      };
    },

    async setFormData(data) {
      if (this.itemData !== null) {
        const {
          membership_program_id,
          description,
          code,
          barcode,
          points_to_redeem,
          status
        } = data;
        await this.getMembershipLevels(membership_program_id);
        const valid_from = moment(data.valid_from).format(this.dateFormat);
        const valid_to = moment(data.valid_to).format(this.dateFormat);

        this.dateRange = [valid_from, valid_to];
        let membershipLevelIds = [];

        if (data.itemMembershipLevels && data.itemMembershipLevels.length > 0) {
          membershipLevelIds = data.itemMembershipLevels.map(
            (item) => item.membership_level_id
          );
        }
        this.formData = {
          membership_program_id,
          description,
          code,
          membership_levels: membershipLevelIds,
          barcode,
          points_to_redeem,
          valid_from,
          valid_to,
          status
        };
      }
    }
  },

  created: async function () {
    await this.getMembershipPrograms();
    await this.setFormData(this.itemData);
  },

  computed: {
    itemStatus: {
      get() {
        return this.formData.status == 'A' ? true : false;
      },
      set(val) {
        this.formData.status = val ? 'A' : 'I';
      }
    }
  },

  watch: {
    itemData: function (data) {
      this.clearForm();
      if (data !== null) {
        this.setFormData(data);
      }
    }
  }
};
</script>

<style scoped></style>
